export default __webpack_public_path__ + "static/cppglass-logo-3baea35786c17880c8610a5513a831d4.png";